import { AppEnviroment } from "../../utilities/app_enviroment";
import * as moment from 'moment';

export class DatepickerMaskService {

    isLeapYear: boolean;
    year: string;
    update: boolean = false;
    temp: string;
    month: string;
    day: string;
    date: string;
    splitVal: string[];
    dayValidation: number;

    public DatePickerProcess(valueDate: string): void {
        if (valueDate.length == 2) {
            AppEnviroment.IsValid = false;
            if (valueDate.substring(1) != "/") {
                this.setResult(this.dateTimeTrashCollector("day", parseInt(valueDate)));
            }
            else if (valueDate.substring(1) == "/") {
                this.setResult(this.dateTimeTrashCollector("day", parseInt(valueDate.charAt(0))) + "/");
            }
        }
        if (valueDate.length == 3) {
            AppEnviroment.IsValid = false;
            if (valueDate.substring(2) != "/" && valueDate.charAt(2) != ".") {
                var val = valueDate.charAt(2);
                this.setResult(this.dateTimeTrashCollector("day", parseInt(valueDate.substring(0, 2))) + "/" + val);
            }
            else if (valueDate.charAt(2) == "/") {
                this.setResult(this.dateTimeTrashCollector("day", parseInt(valueDate.substring(0, 2))) + "/");
            }
            else if (valueDate.charAt(1) == "/" && valueDate.charAt(2) == "/" && valueDate.charAt(1) == "." && valueDate.charAt(2) == ".") {

                this.clearField();
            }
        }
        if (valueDate.length == 4) {
            AppEnviroment.IsValid = false;
            var val = valueDate.charAt(3);
            if ((valueDate.charAt(2) == "/" && valueDate.charAt(3) == "/") || (valueDate.charAt(2) == "." && valueDate.charAt(3) == ".")) {
                this.clearField();
            }
            else if (valueDate.charAt(0) != "/" && valueDate.charAt(3) != "/" && valueDate.charAt(2) != "/") {
                this.setResult(valueDate.slice(0, 1));
            }
            else if (valueDate.substring(0, 3).length == 3 && valueDate.charAt(2) != "/" || valueDate.substring(0, 3).length > 3) {
                this.setResult(valueDate.slice(0, 2) + "/" + valueDate.slice(2, 4));
            }
        }
        if (valueDate.length == 5) {
            AppEnviroment.IsValid = false;
            if (valueDate.charAt(4) == "0" && valueDate.charAt(3) == "0") {
                this.setResult(valueDate.slice(0, 4) + "1/");
            }
            else {
                if (valueDate.charAt(4) != "/") {
                    var val = valueDate.substring(3);
                    if (valueDate.charAt(4) == "0") {
                        //val = val + "1";
                        //this.setResult(valueDate.slice(0, 3) + "01");
                    }
                    else if (valueDate.slice(3, 5) == "00") {
                        this.setResult(valueDate.slice(0, 3) + "01/");
                    }
                    else if (valueDate.charAt(0) === "/" && valueDate.substring(1).length == 4) {
                        if (valueDate.charAt(3) == "/" && valueDate.charAt(0) === "/") {
                            this.clearField();
                        }
                        else {
                            this.setResult("01/01/" + valueDate.substring(1));
                        }
                    }
                    else if (valueDate.charAt(2) != "/" && valueDate.charAt(4) != "/") {
                        this.clearField();
                    }
                    else {
                        val = this.dateTimeTrashCollector("month", parseInt(valueDate.substring(3)));
                        this.setResult(valueDate.slice(0, 3) + val);
                    }
                }
                else if (valueDate.charAt(4) == "/") {
                    if (valueDate.charAt(1) == "/" && valueDate.charAt(4) == "/") {
                        this.setResult(valueDate.slice(0));
                    }
                    else {
                        if (valueDate.charAt(2) != "/") {
                            this.setResult(valueDate.slice(0, 1));
                        }
                        else {
                            var val = valueDate.charAt(3);
                            val = this.dateTimeTrashCollector("month", parseInt(val)) + "/";
                            this.setResult(valueDate.slice(0, 3) + val);
                        }
                    }
                }
                else if (valueDate.charAt(4) == "0") {
                    this.setResult(valueDate.slice(0, 5) + "/");
                }
            }
        }
        if (valueDate.length == 6) {
            AppEnviroment.IsValid = false;
            var value = valueDate.charAt(5);
            if (valueDate.charAt(5) != "/") {
                
                if (value == "0" || value == ".") {
                    this.setResult(valueDate.slice(0, 5) + "/");
                }
                else if (valueDate.charAt(2) != "/") {
                    if (valueDate.charAt(2) != "/" && valueDate.charAt(5) != "/") {
                        this.setResult(valueDate.slice(0, 2) + "/" + valueDate.slice(2, 4))
                    }
                    else {
                        this.setResult(valueDate.slice(0, 2) + valueDate.slice(2, 6));
                    }
                }
                else if (valueDate.charAt(2) == "/" && valueDate.charAt(5) != "/" && valueDate.charAt(4) != "/") {
                    this.setResult(valueDate.slice(0, 5) + "/" + valueDate.charAt(5));
                }
                else if (valueDate.charAt(4) == "/") {
                    if (valueDate.charAt(3) == "0") {
                        this.setResult(valueDate.slice(0, 3) + "01" + valueDate.slice(4, 6));
                    }
                    else {
                        this.setResult(valueDate.slice(0, 6));
                    }
                }
                else {
                    this.setResult(valueDate.slice(0, 2) + "/" + value);
                }
            }
            else if (valueDate.charAt(5) == "/") {
                this.setResult(valueDate.slice(0, 5) + valueDate.charAt(5).toString());
            }
            else if (value.slice(3, 5).length == 3) {
                this.setResult(value.slice(3, 5));
            }
            else if (valueDate.substring(0, 3) === "//") {

                this.clearField();
            }
            else if (valueDate.substring(0) === "/") {

                this.clearField();
            }
            else if (valueDate.substring(5) == "/") {

                this.clearField();
            }
        }
        if (valueDate.length == 7) {
            AppEnviroment.IsValid = false;
            if (valueDate.charAt(6) == "/") {
                var val = valueDate.charAt(6);
                if (val === "0") {
                    this.setResult(valueDate.slice(0, 6) + val.replace(val, ""));
                }
                else if (val === "/") {
                    if (valueDate.charAt(5) != "/") {
                        if (valueDate.charAt(5) != "/" && valueDate.slice(3, 6).length == 3 && valueDate.charAt(6) == "/" && valueDate.charAt(2) == "/") {

                            if (valueDate.charAt(5) == "0") {
                                this.setResult(valueDate.slice(0, 5) + "/");
                            }
                            else {
                                this.setResult(valueDate.slice(0, 5) + valueDate.slice(6, 7) + valueDate.charAt(5));
                            }
                        }
                        else {
                            this.setResult(valueDate.slice(0, 5) + valueDate.slice(6, 7) + valueDate.charAt(5));
                        }
                    }
                    else {
                        this.setResult(valueDate.slice(0, 6) + val.replace(val, ""));
                    }
                }
            }
            else if (valueDate.charAt(6) == "0") {
                var val = valueDate.charAt(6);
                if (valueDate.charAt(5) != "/") {
                    if (valueDate.charAt(4) == "/") {
                        this.setResult(valueDate.slice(0, 3) + "01" + valueDate.slice(4, 7));
                    }
                    else {
                        this.setResult(valueDate.slice(0, 5) + "/" + valueDate.slice(5, 7));
                    }
                }
                else {
                    this.setResult(valueDate.slice(0, 6) + val.replace(val, ""));
                }
            }
            else if (valueDate.charAt(6) == ".") {
                var val = valueDate.charAt(6);
                this.setResult(valueDate.slice(0, 6) + val.replace(val, ""));
            }
            else if (valueDate.split("/").length == 2) {
                if (valueDate.substring(2, 6).length == 4 && valueDate.charAt(5) != "/") {
                    if (valueDate.charAt(2) != "/") {
                        this.setResult(valueDate.slice(0, 2) + "/" + valueDate.slice(2, 7));
                    }
                    else if (valueDate.slice(3, 7).length == 4 && valueDate.charAt(5) != "/") {
                        this.setResult(valueDate.slice(0, 5) + "/" + valueDate.slice(5, 7));
                    }
                    else {
                        var val = valueDate.substring(5);
                        this.setResult(valueDate.slice(0, 2) + "/" + valueDate.slice(3, 5) + "/" + val);
                    }
                }
                else {
                    var val = "01/" + "01/" + valueDate.substring(3, 7);
                    this.setResult(val);
                }
            }
            else if (valueDate.charAt(5) != "/") {
                this.clearField();
            }
            else if (valueDate.slice(2, 7).length == 4) {
                this.clearField();
            }
        }
        if (valueDate.length == 8) {
            AppEnviroment.IsValid = false;
            if (valueDate.charAt(7) == "/" || valueDate.charAt(7) == ".") {
                var val = valueDate.charAt(7);
                this.setResult(valueDate.slice(0, 7) + val.replace(val, ""));
            }
            else if (valueDate.charAt(6) == "0" || valueDate.charAt(7) == "." && parseInt(valueDate.charAt(6)) > 0) {
                var val = valueDate.substring(5);
                if (val === "/00") {
                    this.setResult(valueDate.slice(0, 6) + AppEnviroment.MinYear);
                }
                else {
                    this.setResult(valueDate.slice(0, 5) + "/" + val);
                }
            }
            else if (valueDate.charAt(5) != "/") {
                if (valueDate.charAt(0) == "/") {
                    this.setResult("01" + valueDate.slice(0, 8));
                }
                else if (valueDate.charAt(3) == "/") {
                    if (valueDate.charAt(2) != "/") {
                        this.setResult(valueDate.slice(0, 2) + "/" + this.dateTimeTrashCollector("month", parseInt(valueDate.charAt(2))) + valueDate.slice(3, 8));
                    }
                    else {
                        this.setResult(valueDate.substring(0, 3) + "1" + "/" + valueDate.slice(4, 8));
                    }
                }
                else if (valueDate.slice(3, 8).length == 5) {
                    if (valueDate.charAt(4) == "/") {
                        if (valueDate.charAt(2) != "/") {
                            if (valueDate.charAt(1) == "/") {
                                this.clearField();
                            }
                            else {
                                this.setResult(valueDate.slice(0, 2) + "/" + valueDate.slice(2, 8));
                            }
                        }
                        else {
                            this.setResult(valueDate);
                        }
                    }
                    else if (valueDate.charAt(4) != "/") {
                        if (valueDate.charAt(6) == "/" && valueDate.charAt(5) != "/") {
                            this.setResult(valueDate.slice(0, 5) + valueDate.slice(6, 8) + valueDate.charAt(5));
                        }
                        else {
                            this.setResult(valueDate.slice(0, 5) + "/" + valueDate.slice(5, 8));
                        }
                    }
                }
                else {
                    this.setResult(valueDate.slice(0));
                }
            }
        }
        if (valueDate.length == 9) {
            AppEnviroment.IsValid = false;
            if (parseInt(valueDate.slice(3, 5)) > 12) {
                if (valueDate.charAt(5) != "/") {
                    this.setResult(valueDate.slice(0, 5) + valueDate.replace(valueDate.charAt(5), "/") + valueDate.charAt(5) + valueDate.slice(6, 9));
                }
                else if (valueDate.charAt(5) === "/") {
                    this.setResult(valueDate.slice(0, 3) + "12" + valueDate.slice(5, 9));
                }
            }
            if (valueDate.charAt(8) == "/" || valueDate.charAt(7) == ".") {
                var val = valueDate.charAt(8);
                if (valueDate.charAt(5) != "/") {
                    this.setResult(valueDate.slice(0, 5) + valueDate.replace(valueDate.charAt(5), "/") + valueDate.charAt(5) + valueDate.slice(6, 9));
                }
                else if (valueDate.charAt(5) === "/") {
                    this.setResult(valueDate.slice(0, 8) + val.replace(val, ""));
                }
            }
            else if (valueDate.substring(6) === "000") {
                var val = valueDate.charAt(5);
                if (val == "/") {
                    this.setResult(valueDate.slice(0, 6) + AppEnviroment.MinYear);
                }
                else if (valueDate.charAt(4) == "/") {
                    this.setResult(valueDate.slice(0, 3) + "01/" + valueDate.slice(5, 9));
                }
                else {
                    this.setResult(valueDate.slice(0, 5) + '/');
                }
            }
            else if (valueDate.charAt(2) != "/") {
                if (valueDate.charAt(2) == "/" && valueDate.substring(0, 2).length == 2) {
                    this.setResult(valueDate.slice(0));
                }
                else if (valueDate.charAt(2) != "/") {
                    if (valueDate.slice(0, 4).length == 4) {
                        if (valueDate.charAt(1) == "/") {
                            this.setResult(valueDate);
                        }
                        else {
                            var val = valueDate.slice(2, 4);
                            this.setResult(valueDate.slice(0, 2) + "/" + val + valueDate.slice(4, 9));
                        }
                    }
                    else {
                        var val = valueDate.charAt(2);
                        this.setResult(valueDate.substring(0, 2) + "/" + val + valueDate.slice(3, 10));
                    }
                }
            }
            else if (valueDate.charAt(6) === "0") {
                if (valueDate.charAt(4) === "/" && valueDate.charAt(5) != "/") {
                    this.setResult(valueDate.slice(0, 4));
                } else if (valueDate.slice(3, 5).length == 2 && valueDate.charAt(5) != "/") {
                    this.setResult(valueDate.slice(0, 5) + "/");
                }
            }
            else if (valueDate.charAt(5) != "/") {

                if (valueDate.slice(3, 9).length == 6 && valueDate.charAt(5) != "/" && valueDate.charAt(2) == "/") {
                    if (valueDate.charAt(4) == "/") {
                        this.setResult(valueDate);
                    }
                    else if (valueDate.substring(2, 4).length == 2 && valueDate.charAt(5) != "/") {
                        if (valueDate.charAt(5) != "/" && valueDate.charAt(6) == "/") {
                            this.setResult(valueDate.slice(0, 5) + valueDate.slice(6, 9) + valueDate.charAt(5));
                        }
                        else {
                            //var val = valueDate.charAt(5);
                            //this.setResult(valueDate.slice(0, 5) + "/" + val + valueDate.slice(6, 9));
                            this.setResult(valueDate.slice(0, 5) + "/");
                        }
                    }
                }
            }
        }
        if (valueDate.length == 10) {
            if (valueDate.charAt(5) != "/" && valueDate.charAt(6) == "/" && valueDate.slice(7, 10).length == 3) {
                this.setResult(valueDate.slice(0, 5) + "/" + this.dateTimeTrashCollector("year", parseInt(valueDate.slice(7, 10) + valueDate.charAt(5))));
            }
            else if (valueDate.charAt(6) === "0") {
                this.setResult(valueDate.slice(0, 6) + AppEnviroment.MinYear);
            }
            else if (valueDate.charAt(9) == "/") {
                this.setResult(valueDate.slice(0, 9));
            }
            else if (valueDate.charAt(5) != "/") {
                if (valueDate.charAt(4) == "/" && valueDate.slice(5, 10).length == 5) {
                    this.setResult(valueDate.slice(0, 3) + "01/" + valueDate.slice(5, 9));
                }
                else if (valueDate.charAt(5) != "/" && valueDate.charAt(6) == "/") {
                    var val = valueDate.charAt(5);
                    this.setResult(val);
                }
            }
            else if (valueDate.charAt(6) == "0") {
                this.year = AppEnviroment.MinYear;
            }

            if (valueDate.split("/").length == 3 && valueDate.slice(3, 5).length == 2 && valueDate.charAt(2) == "/" && valueDate.charAt(5) == "/" && valueDate.slice(0, 2).length == 2 && valueDate.slice(6, 10).length == 4) {
                this.day = this.dateTimeTrashCollector("day", parseInt(valueDate.slice(0, 2)));
                this.month = this.dateTimeTrashCollector("month", parseInt(valueDate.slice(3, 5)));
                this.year = this.dateTimeTrashCollector("year", parseInt(valueDate.slice(6, 10)));

                if (parseInt(this.year) == parseInt(AppEnviroment.MaxYear)) {
                    this.setResult(AppEnviroment.MaxDate);
                }
                else if (parseInt(this.year) == parseInt(AppEnviroment.MinYear)) {
                    this.setResult(AppEnviroment.MinDate);
                }
                else if (parseInt(this.year) < parseInt(AppEnviroment.MaxYear) && parseInt(this.year) > parseInt(AppEnviroment.MinYear)) {
                    var valDate = this.dateValidator("GetPrep-OP", this.day, this.month, this.year);
                    if (Boolean(valDate)) {
                        AppEnviroment.IsValid = true;
                        this.setResult(valDate);
                        this.dayValidation = 0;
                    }
                    else if (!Boolean(valDate)) {
                        this.dayValidation = 0;
                        AppEnviroment.IsValid = false;
                    }
                }
            }
        }

        if (valueDate.length == 1) {
            if (valueDate.charAt(0) == "/" || valueDate.charAt(0) == ".") {
                this.clearField();
            }
        }
        if (valueDate.length > 10) {
            this.clearField();
        }
        if (valueDate.slice(1, 3) === "//") {
            this.setResult(valueDate.slice(0));
        }
        if (valueDate.slice(2, 4) === "//") {
            this.setResult(valueDate.slice(0, 2));
        }
        if (valueDate.slice(0, 5).length == 5 && valueDate.charAt(2) != "/") {
            this.setResult(valueDate.slice(0, 2));
        }
        if (valueDate.slice(4, 6) == "//") {
            this.setResult(valueDate.slice(0, 4));
        }
    }
    protected dateTimeTrashCollector(_val: string, _valForMonth: number): string {
        switch (_val) {
            case "month":
                if (_valForMonth <= 12) {
                    if (_valForMonth.toString().length == 1) {
                        if (_valForMonth == 0) {
                            return this.month = (_valForMonth + "1").toString();
                        }
                        else if (_valForMonth < 10) {
                            return this.month = ("0" + _valForMonth).toString();
                        }
                    }
                    else if (_valForMonth.toString().length == 2) {
                        return this.month = (_valForMonth).toString();
                    }
                }
                else if (_valForMonth > 12) {
                    return this.month = "12";
                }
            case "day":
                if (_valForMonth.toString().length == 1) {
                    if (_valForMonth == 0) {
                        return this.day = "01";
                    }
                    else if (_valForMonth < 10) {
                        return this.day = ("0" + _valForMonth).toString();
                    }
                }
                else if (_valForMonth.toString().length == 2) {
                    if (_valForMonth >= 10 && _valForMonth <= 31) {
                        return this.day = _valForMonth.toString();
                    }
                    else if (_valForMonth > 31) {
                        return this.day = "31";
                    }
                }
            case "year":
                if (_valForMonth.toString().length == 4) {
                    if (_valForMonth <= parseInt(AppEnviroment.MaxYear) && _valForMonth >= parseInt(AppEnviroment.MinYear)) {
                        return _valForMonth.toString();
                    }
                    else if (_valForMonth < parseInt(AppEnviroment.MinYear)) {
                        return AppEnviroment.MinYear;
                    }
                    else if (_valForMonth > parseInt(AppEnviroment.MaxYear)) {
                        return AppEnviroment.MaxYear;
                    }
                }
            default:
                return "01";
        }
    }
    private dateValidator(caseName: string, day: string, month: string, year: string): string {
        switch (caseName) {
            case "GetPrep-OP":
                if ((moment([year]).isLeapYear())) {
                    return ((this.monthValidator(moment(parseInt(month), 'MM').format('MMMM'), true, day, parseInt(month))) + "/" + this.year);
                }
                else if (!(moment([year]).isLeapYear())) {
                    return ((this.monthValidator(moment(parseInt(month), 'MM').format('MMMM'), false, day, parseInt(month))) + "/" + this.year);
                }
            default:
                return "false";
        }
    }
    private monthValidator(caseVal: string, isLeap: boolean, days: string, monthInNum: number): string {
        if (days === "0") {
            AppEnviroment.IsValid = false;
            return "";
        }
        else {
            switch (caseVal) {
                case "January":
                    return days + "/0" + monthInNum;
                case "February":
                    if (isLeap) {
                        if (parseInt(days) > 29) {
                            return "0" + ((parseInt(days) - 29) + "/0" + (monthInNum + 1)).toString();
                        }
                        else {
                            return days + "/0" + monthInNum;
                        }
                    }
                    else {
                        if (parseInt(days) > 28) {
                            return "0" + ((parseInt(days) - 28) + "/0" + (monthInNum + 1)).toString();
                        }
                        else {
                            return days + "/0" + monthInNum;
                        }
                    }
                case "March":
                    return days + "/0" + monthInNum;
                case "April":
                    if (parseInt(days) > 30) {
                        return "0" + ((parseInt(days) - 30) + "/0" + (monthInNum + 1)).toString();
                    }
                    else {
                        return days + "/0" + monthInNum;
                    }
                case "May":
                    return days + "/0" + monthInNum;
                case "June":
                    if (parseInt(days) > 30) {
                        return "0" + ((parseInt(days) - 30) + "/0" + (monthInNum + 1)).toString();
                    }
                    else {
                        return days + "/0" + monthInNum;
                    }
                case "July":
                    return days + "/0" + monthInNum;
                case "August":
                    return days + "/0" + monthInNum;
                case "September":
                    if (parseInt(days) > 30) {
                        return "0" + ((parseInt(days) - 30) + "/" + (monthInNum + 1)).toString();
                    }
                    else {
                        return days + "/0" + monthInNum;
                    }
                case "October":
                    return days + "/" + monthInNum;
                case "November":
                    if (parseInt(days) > 30) {
                        return "0" + ((parseInt(days) - 30) + "/" + (monthInNum + 1)).toString();
                    }
                    else {
                        return days + "/" + monthInNum;
                    }
                case "December":
                    return days + "/" + monthInNum;
                default:
                    return days + "/" + monthInNum;
            }
        }
    }
    private clearField(): void {
        (<HTMLInputElement>document.getElementById(AppEnviroment.DatePickerID)).value = "";
    }
    private setResult(result: string): void {
        (<HTMLInputElement>document.getElementById(AppEnviroment.DatePickerID)).value = result;
    }
}
